export default function AudienceSection() {
  const cards = [
    {
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          <polyline points="9 12 11 14 15 10" />
        </svg>
      ),
      title: 'Experiência em gestão pública e organização autárquica',
      description: 'A GestPub trabalha exclusivamente com entidades públicas e autarquias portuguesas, com conhecimento aprofundado da realidade da Administração Pública local.',
    },
    {
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
          <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 00-3-3.87" />
          <path d="M16 3.13a4 4 0 010 7.75" />
        </svg>
      ),
      title: 'Equipa multidisciplinar com conhecimento técnico e estratégico',
      description: 'Uma equipa com formação em gestão pública, direito administrativo, recursos humanos e organização de serviços, orientada para resultados concretos.',
    },
    {
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
          <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
          <polyline points="14 2 14 8 20 8" />
          <polyline points="9 15 11 17 15 13" />
        </svg>
      ),
      title: 'Metodologias adaptadas à realidade dos Municípios',
      description: 'Instrumentos e abordagens desenvolvidos especificamente para a administração local, com respeito pelas especificidades legais, orgânicas e culturais de cada autarquia.',
    },
    {
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
          <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" />
        </svg>
      ),
      title: 'Capacidade de transformar diagnóstico em plano de ação',
      description: 'O diagnóstico é o ponto de partida. A GestPub acompanha o Município desde a análise inicial até à implementação das medidas de melhoria identificadas.',
    },
  ];

  return (
    <section id="porque-gestpub" className="py-20 lg:py-24" style={{ backgroundColor: '#F8F9FA' }}>
      <div className="max-w-6xl mx-auto px-6">
        {/* Section header */}
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-4">
            <div className="h-px w-8" style={{ backgroundColor: '#D1D5DB' }} />
            <span style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.7rem', fontWeight: 600, letterSpacing: '0.12em', textTransform: 'uppercase', color: '#9CA3AF' }}>
              Porquê a GestPub
            </span>
          </div>
          <h2
            style={{ fontFamily: 'DM Sans, sans-serif', fontWeight: 700, maxWidth: '36ch', fontSize: 'clamp(1.5rem, 3vw, 1.875rem)', lineHeight: 1.25, color: '#1a1a1a', marginBottom: '0.875rem', letterSpacing: '-0.02em' }}
          >
            Porquê a GestPub?
          </h2>
          <p
            style={{ maxWidth: '56ch', fontFamily: 'DM Sans, sans-serif', fontSize: '0.95rem', color: '#6B7280', lineHeight: 1.75 }}
          >
            A GestPub conhece a realidade da Administração Pública local e apoia entidades públicas na construção de soluções técnicas, estratégicas e operacionais orientadas para resultados.
          </p>
        </div>

        {/* 2x2 grid */}
        <div className="grid md:grid-cols-2 gap-4">
          {cards?.map((item) => (
            <div
              key={item?.title}
              className="flex gap-5 p-7 bg-white"
              style={{ borderRadius: '6px', border: '1px solid #E5E7EB' }}
            >
              <div
                className="flex-shrink-0 flex items-center justify-center"
                style={{ width: '2.5rem', height: '2.5rem', borderRadius: '5px', backgroundColor: 'rgba(0,150,136,0.08)', color: '#009688', border: '1px solid rgba(0,150,136,0.15)', flexShrink: 0 }}
              >
                {item?.icon}
              </div>
              <div>
                <h4
                  style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '1rem', fontWeight: 700, color: '#1a1a1a', marginBottom: '0.4rem', letterSpacing: '-0.01em' }}
                >
                  {item?.title}
                </h4>
                <p
                  style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.875rem', color: '#6B7280', lineHeight: 1.7 }}
                >
                  {item?.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA nudge */}
        <div className="mt-10 pt-8" style={{ borderTop: '1px solid #E5E7EB' }}>
          <a
            href="https://www.gestpub.pt/gp-otimiza/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 transition-colors duration-200"
            style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.875rem', fontWeight: 500, color: '#6B7280' }}
            onMouseEnter={(e) => (e.currentTarget.style.color = '#009688')}
            onMouseLeave={(e) => (e.currentTarget.style.color = '#6B7280')}
          >
            <span>Saber mais sobre a GestPub</span>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
}